import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// slider
import { tns } from "tiny-slider/src/tiny-slider";

import AOS from 'aos';
AOS.init();

[].forEach.call(document.querySelectorAll('.slider'), function (el) {
    tns({
        container: el,
        slideBy: 'page',
        items : 1,
        slideBy : 1,
        gutter: 30,
        autoplay: true,
        controls: false,
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        autoplayTimeout : 5000,
        responsive: {
            768: {
                items: 2
            },
            1024: {
                items: 3
            },
        }
    });
});